import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";
import { isValidEmail } from "../../../utils/Utils";

const MyEmail = ({
  title,
  name,
  register,
  watch,
  trigger,
  errors,
  setValue,
  placeholder,
  required,
  min,
  max,
  disabled,
}) => {
  return (
    <div className="form-group my-2">
      <Label className="from-label" htmlFor={name}>
        {title}
        {required && <Required />}
      </Label>
      <div className="form-control-wrap">
        <input
          placeholder={"Enter email address"}
          type="text"
          id="email"
          {...register("email", {
            required: {
              value: required,
              message: "Email address is required",
            },
            validate: {
              isValid: (value) => isValidEmail(value) || "Enter valid email address",
            },
          })}
          className={`form-control ${errors?.[name] ? "is-invalid" : ""}`}
          value={watch("email")}
          onChange={(e) => {
            setValue("email", e.target.value);
            trigger("email");
          }}
        />
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyEmail;
